import {Button} from '@material-ui/core';
import React from 'react';
import Modal from 'Shared/components/Modal';
import {toFormattedDateTime} from 'Shared/utilities/DateFormatter';
import {Async, isLoaded} from 'Core/models/Async';
import {EnrollmentFileStatus} from 'Enrollment/models/EnrollmentFilesNotProcessed';

type EnrollmentStatusModalProps = {
  onClose: () => void;
  open: boolean;
  data: Async<EnrollmentFileStatus>;
};

const EnrollmentStatusModal = (props: EnrollmentStatusModalProps) => {
  const {onClose, open, data} = props;
  return (
    <Modal onClose={onClose} open={open} title="File Status">
      <div className="hierarchy__container">
        <p>Date: {isLoaded(data) ? toFormattedDateTime(data.Data.sourceFileCreateDate!) : ''}</p>
        <p>File Recognized: {isLoaded(data) ? data.Data.fileHistoryStatus : ''}</p>
        <p>File Schedule: {isLoaded(data) ? data.Data.scheduleHistoryStatus : ''}</p>
        <Button color="primary" variant="contained" fullWidth onClick={onClose}>
          Close
        </Button>
      </div>
    </Modal>
  );
};

export default EnrollmentStatusModal;
